var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"rssButton",attrs:{"icon":""},on:{"click":_vm.showShareRssModal}},[_c('img',{attrs:{"src":_vm.rssDetails.logo,"alt":_vm.rssAltText}})])
}
var staticRenderFns = []

export { render, staticRenderFns }